<template>
<div>
    <div></div>
</div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import moment from "moment"

export default {
    components: {
        VueApexCharts
    },
    props: {},

    data: function () {
        return {
            options: {
                series: [44, 55, 13, 33],
                chartOptions: {
                    labels: ['Apple', 'Mango', 'Orange', 'Watermelon']
                },
                chart: {
                    type: 'donut'
                }
            }
        }
    }
};
</script>

<style>
</style>
